import { render, staticRenderFns } from "./classclassification_modal.vue?vue&type=template&id=c8c1b270&"
import script from "./classclassification_modal.vue?vue&type=script&lang=js&"
export * from "./classclassification_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports